import { TypePolicy } from '@apollo/client';

const Vital: TypePolicy = {
  keyFields: ['vitalId'],
};

export default Vital;
